import { useEffect } from 'react'
import { Provider } from 'react-redux'
import App from 'containers/App'

import 'containers/Root.less'

interface RootProps {
  store: any
}

const Root = ({ store }: RootProps) => {
  useEffect(() => {
    const name = location.hostname?.split('.')[0] || 'Xiagram'
    document.title = name.charAt(0).toUpperCase() + name.slice(1)
  }, [])

  return (
    <Provider store={store}>
      <div className="root-component">
        <App />
      </div>
    </Provider>
  )
}

export default Root
